import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { formatPrice } from '../../utils/currency';
import { FaStar } from 'react-icons/fa';
import { useThemeClasses } from '../../hooks/useThemeClasses';

export default function MoreSellersSection({
  listings = [],
  currentListingId,
  nodeId,
  column,
  vehicleId,
  loading,
}) {
  const [expanded, setExpanded] = useState(false);
  const { isDark, sc } = useThemeClasses();

  const others = listings.filter((l) => l.listingId !== currentListingId);
  if (!others.length && !loading) return null;

  const minPrice = others.length
    ? Math.min(...others.map((l) => l.price))
    : null;

  const buildLink = (listingId) => {
    const p = new URLSearchParams();
    if (vehicleId) p.set('vehicleId', vehicleId);
    if (column) p.set('column', column);
    if (nodeId) {
      if (String(nodeId).length === 64) p.set('catalogNodeId', nodeId);
      else p.set('nodeId', nodeId);
    }
    const qs = p.toString();
    return `/catalog/part-p-${listingId}${qs ? `?${qs}` : ''}`;
  };

  return (
    <div className={sc('pdpAccordion')}>
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className={`flex w-full items-center justify-between px-4 py-3.5 text-left text-sm font-semibold transition-colors ${
          isDark
            ? 'text-slate-200 hover:bg-slate-800/50'
            : 'text-slate-800 hover:bg-slate-50'
        }`}
      >
        <span>
          {loading
            ? 'Loading sellers…'
            : `${others.length} more seller${others.length === 1 ? '' : 's'} from ${formatPrice(minPrice)}`}
        </span>
        <span className={isDark ? 'text-slate-500' : 'text-slate-400'}>{expanded ? '▲' : '▼'}</span>
      </button>
      {expanded && others.length > 0 && (
        <ul
          className={`divide-y border-t ${
            isDark ? 'divide-slate-700/40 border-slate-700/60' : 'divide-slate-100 border-slate-200'
          }`}
        >
          {others.map((item) => (
            <li key={item.listingId}>
              <Link
                to={buildLink(item.listingId)}
                className={`flex items-center justify-between gap-3 px-4 py-3 transition-colors ${
                  isDark ? 'hover:bg-slate-800/60' : 'hover:bg-slate-50'
                }`}
              >
                <div className="min-w-0">
                  <p className={`truncate text-sm font-medium ${isDark ? 'text-slate-200' : 'text-slate-800'}`}>
                    {item.brand || item.name}
                  </p>
                  <p className={`flex items-center gap-1 text-xs ${isDark ? 'text-slate-400' : 'text-slate-500'}`}>
                    <FaStar className="text-amber-400" />
                    {Number(item.rating || item.sellerRating || 0).toFixed(1)}
                    {item.etaLabel && ` · ${item.etaLabel}`}
                  </p>
                </div>
                <span className={`shrink-0 font-bold ${isDark ? 'text-amber-400' : 'text-amber-700'}`}>
                  {formatPrice(item.price)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
